import { SwitchBreakpointAction, SWITCH_BREAKPOINT } from './action-creators';
import { Action } from 'redux';

export default function(state: number | null = null, action: Action, appShellData: Scope.AppShellDataBase): number {
  if (state === null) {
    state = appShellData.guessedBreakpoint;
  }
  switch (action.type) {
    case SWITCH_BREAKPOINT:
      return (action as SwitchBreakpointAction).newBreakpoint;
    default:
      return state;
  }
}
